<template>
  <div class="share-drawer" v-loading="linkLoading">
    <div class="topWord" v-if="!isAdmin">
      <i class="el-icon-warning-outline ml-6 mr-1 leading-22"></i>
      <span>调查员信息收集表由企业管理员设置，如需修改，请联系企业管理员</span>
    </div>

    <!-- 链接部分 -->
    <div class="flex-1 pt-4">
      <p class="px-6">
        <span class="text-theme-black-850 text-medium-x font-semibold">链接海报邀请</span>
      </p>
      <div class="scrollbar overflow-x-auto">
        <div class="flex mx-6 mqc-minw-px">
          <div class="flex-3 flex flex-col justify-center">
            <!-- 复制链接 -->
            <div class="flex justify-between" v-show="pause">
              <div class="relative flex-1">
                <el-input class="gray-border bg-white-input gray-text-450" :value="pcUrl" readonly size="small"></el-input>
                <el-button
                  class="absolute right-0 copy-link-btn normal-button rounded-l-none"
                  size="small"
                  type="primary"
                  @click="copyUrl('.copy-link-btn', pcUrl)"
                  >复制</el-button
                >
              </div>
              <div class="ml-2">
                <el-button class="normal-button" size="small" @click="openByUrlHandle">打开</el-button>
              </div>
            </div>
            <!-- 获取二维码 -->
            <div class="mt-5">
              <el-button
                type="primary"
                class="mr-5"
                @click="
                  downloadPoster({
                    qrText,
                    downloadName: downloadName(),
                    downloadSub
                  })
                "
                >获取二维码海报</el-button
              >
              <span class="text-small text-black text-opacity-65 mr-2"> 暂停发布 </span>
              <el-switch v-model="pause" :disabled="!isAdmin" />
            </div>
            <!--  -->
          </div>
          <div class="flex-3 flex justify-end" v-show="pause">
            <scan-answer class="mr-16" :qr-text="qrText" :download-name="downloadName('二维码')" />
          </div>
        </div>
      </div>
    </div>

    <!-- 分享部分 -->
    <div class="flex-3 pt-10">
      <p class="px-5">
        <span class="text-theme-black-850 text-medium-x font-semibold">分享给好友</span>
        <span class="text-small text-theme-black-450">（可自定义微信分享链接样式）</span>
      </p>
      <div class="pb-6 scrollbar overflow-x-auto">
        <share class="mqc-minw-px" :share-text="qrText" :wj-detail="wjDetail" :isAdmin="isAdmin" />
      </div>
    </div>

    <!-- 调查员数据更新规则 -->
    <div class="text-theme-black-850 text-medium-x font-semibold px-6 mb-4">调查员数据更新规则</div>
    <div class="mb-6 px-6">一个手机号对应一个调查员</div>
    <div class="flex mb-4 px-6">
      <div class="mr-4 leading-24">同一调查员，调查员已有值，导入值为空时</div>
      <el-radio-group v-model="nullValueRule" class="mt-1" @change="changeRule">
        <el-radio :label="0" :disabled="!isAdmin">使用导入值</el-radio>
        <el-radio :label="1" :disabled="!isAdmin">保留已有值</el-radio>
      </el-radio-group>
    </div>
    <div class="flex mb-4 px-6">
      <div class="mr-4 leading-24">同一调查员，调查员已有值，但和导入值不相同时</div>
      <el-radio-group v-model="differentValueRule" class="mt-1" @change="changeRule">
        <el-radio :label="0" :disabled="!isAdmin">使用导入值</el-radio>
        <el-radio :label="1" :disabled="!isAdmin">保留已有值</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import Share from './Share'
import GlobalConfig from '@/global/config'
import { getAnswerUrl } from '@/assets/js/utils'
import { createPopup } from '@/assets/js/factory'
import ScanAnswer from '@/components/base/ScanAnswer'
import { copyText, downloadFileByUrl } from '@dygc/shared'
import QrPictorialDialog from '@/components/dialog/QrPictorialDialog'
import { qrMixins, preWjMixins } from '@/mixins/qr-mixins'
import { SURVEY_PUBLISH_STATUS } from '@/global/config-variable'
import { changeLinkUrlState, getFreeLink, removeLinkUrl, getShortLink } from '@/api/wenjuan/publish'
import { updateOrSaveSyncById, getInvestigatorSync } from '@/api/more-app/investigator-base'

export default {
  name: 'InvestigatorShareDrawer',
  mixins: [qrMixins, preWjMixins],
  components: {
    Share,
    ScanAnswer,
    QrPictorialDialog
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isPer() {
      return GlobalConfig.getCompanyId() == 0
    },
    pause: {
      get() {
        return this.freeData.activeFlag
      },
      set(bool) {
        if (bool) {
          this.$store.commit('SET_PUBLISH_STATUS', SURVEY_PUBLISH_STATUS.RECYCLING)
        } else {
          this.$store.commit('SET_PUBLISH_STATUS', SURVEY_PUBLISH_STATUS.CLOSED)
        }
        this.changePauseHandle(bool)
      }
    },
    downloadSub() {
      if( this.isPer ) {
        return `title_海报`
      }else {
        return `${GlobalConfig.getCompanyName()}_title_海报`
      }
    }
  },
  data() {
    return {
      linkLoading: false,
      nullValueRule: 1,
      differentValueRule: 0,
      answerType: 'investigator'
    }
  },
  methods: {
    // 调查员数据更新规则
    changeRule(val) {
      let data = {
        surveyId: GlobalConfig.getSurveyId(),
        syncImportNull: this.nullValueRule,
        syncImportDiff: this.differentValueRule
      }
      updateOrSaveSyncById(data)
        .then(res => {
          if (res.data.code !== 0) return
          this.$message.success('更新规则设置成功')
        })
        .catch(err => {
          console.log(err)
        })
    },
    changePauseHandle(bool) {
      const { id } = this.freeData
      const params = {
        id,
        activeFlag: +bool
      }
      changeLinkUrlState(params)
        .then(() => {
          this.freeData.activeFlag = !!bool
        })
        .catch(() => {})
    },
    // 打开问卷链接
    openByUrlHandle() {
      window.open(this.pcUrl)
    },
    // 海报下载
    downloadPoster(props = {}) {
      createPopup(QrPictorialDialog, props, { store: this.$store })
    },
    copyUrl(btnStr, url) {
      const storeTitle = GlobalConfig.getSurveyTitle() || ''
      const title = storeTitle ? `《${storeTitle}》` : ''
      const urlText = `${url || ''}${url ? '，' : ''}快来参与${title}吧。【调研工厂提供支持】`
      copyText(btnStr, urlText)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
    },
    getInvestigator() {
      getInvestigatorSync()
        .then(res => {
          if (res.data.code !== 0) return
          this.nullValueRule = res.data.data.syncImportNull
          this.differentValueRule = res.data.data.syncImportDiff
        })
        .catch(err => {
          console.log(err)
        })
    },
    downloadName(type='海报') {
      return `${this.isPer?'':GlobalConfig.getCompanyName()+'_'}${GlobalConfig.getSurveyTitle()}_${type}`
    }
  },
  mounted() {
    this.getLinkUrl()
    this.getInvestigator()
  }
}
</script>

<style scoped lang="scss">
.topWord {
  background: rgba(232, 163, 27, 0.1);
  @apply text-yellow-theme text-xs py-1 leading-22;
}
.custom_icon {
  position: absolute;
  top: -7px;
  right: -18px;
}
.mqc-minw-px {
  @apply pt-4;
}
::v-deep .el-radio__label {
  @apply text-medium-x;
}
</style>
